import React from 'react';
type Variant = 'primary' | 'outline' | 'onDark' | 'onDarkSolid';
type Size = 'md' | 'lg';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  fullWidth?: boolean;
}
const base = 'inline-flex items-center justify-center gap-2 rounded-full font-display font-semibold tracking-[-0.01em] transition-[background-color,border-color,color,transform] duration-150 ease-smooth focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-accent active:translate-y-[1px] disabled:opacity-60 disabled:pointer-events-none';
const variants: Record<Variant, string> = {
  primary: 'bg-accent text-white hover:bg-accent-dark',
  outline: 'border border-ink/25 text-ink bg-white hover:border-ink hover:bg-canvas',
  onDark: 'border border-white/30 text-white hover:border-white hover:bg-white/10 focus-visible:ring-white',
  onDarkSolid: 'bg-white text-ink hover:bg-canvas focus-visible:ring-white'
};
const sizes: Record<Size, string> = {
  md: 'h-11 px-5 text-[15px]',
  lg: 'h-[54px] px-6 text-base'
};
export function Button({
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  className = '',
  type = 'button',
  ...rest
}: ButtonProps) {
  return <button type={type} className={`${base} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`} {...rest} data-id="element-58" data-mp="39jg6ui7tack" />;
}